<template>
  <div class="searchtable-container">
    <div 
      class="search-categorie"
      v-for="(result, key) in allResults"
      :key="key"
      v-if="result.length != 0"
    >
      <h3 v-if="result.length != 0">{{ stringWithCapital(key)}}</h3>
      <LotTable v-if="key == 'lot' && result.length != 0" :lots="result" @selectedRow="selectItem" :hasAmountDropdown="false"/>
      <OrderTable v-if="key == 'order' && result.length != 0" :orders="result" @selectedRow="selectItem" :hasAmountDropdown="false"/>
      <RawMatTable v-if="key == 'rawMaterial' && result.length != 0" :rawMats="result" @selectedRow="selectItem" :hasAmountDropdown="false"/>
      <FlowsTable v-if="key == 'flows' && result.length != 0" :flows="result" @selectedRow="selectItem" :hasAmountDropdown="false"/>
      <StepsTable v-if="key == 'steps' && result.length != 0" :steps="result" @selectedRow="selectItem" :hasAmountDropdown="false"/>
      <DevicesTable v-if="(key == 'assemblies' && result.length != 0) || (key == 'singles' && result.length != 0) || (key == 'subparts' && result.length != 0)" @selectedRow="selectItem" :devices="result" :hasAmountDropdown="false"/>
      <DHRTable v-if="key == 'DHF' && result.length != 0" @selectedRow="selectItem" :DHRecords="result" :hasAmountDropdown="false"/>
    </div>
  </div>
</template>

<script>
import LotTable from "@/components/TblLot";
import OrderTable from "@/components/TblOrder";
import RawMatTable from "@/components/TblRawMat";
import FlowsTable from "@/components/TblFlows";
import StepsTable from "@/components/TblSteps";
import DevicesTable from "@/components/TblDevices";
import DHRTable from "@/components/TblDHR";

export default {
  components: {
    LotTable,
    OrderTable,
    RawMatTable,
    FlowsTable,
    StepsTable,
    DevicesTable,
    DHRTable
  },
  props: {
    allResults: Object
  },
  data() {
    return {
    };
  },
  methods: {
    stringWithCapital(val) {
      return val.charAt(0).toUpperCase() + val.slice(1)
    },
    selectItem(val) {
      this.$emit('getSelection', val);
    }
  },
  watch: {
    allResults: function() {
      this.setSelectedData()
    }
  }
};
</script>

<style lang="scss">
@import "@/style/base.scss";
@import "@/style/pages/search.scss";

.searchtable-container {
  max-height: 88vh;
  overflow-y: scroll;
  flex: 1;
  display: flex;
  flex-direction: column;
  border-radius: 8px;

}

</style>